export class PlateSimpleModel {

  id: number;
  version: number;
  suffix: string;
  plateIndex: number;

  static fromData(data: PlateSimpleModel): PlateSimpleModel {
    if (!data) return null;
    return Object.assign(new PlateSimpleModel(), data);
  }

}
